export default __webpack_public_path__ + "static/media/tutup-button.9ba96145.png";